export default __webpack_public_path__ + "static/Trondheim_kommune-e59a5c1772ede0bbe3bca4fbf628c8dd.png";